// dependencies
import React, { useState } from 'react';
import './Calculator.css';

let formula2016 = [5, 5, 5, 10, 15, 20, 25, 15];
let formula2010 = [5, 5, 5, 15, 15, 20, 25, 10];
let final_result = '';

const Calculator = () => {
   const [regulation, setRegulation] = useState('2016');
   const [finalResult, setFinalResult] = useState();
   const [grade, setGrade] = useState('');

   const submitCalc = (e) => {
      e.preventDefault();

      const { first, second, third, fourth, fifth, sixth, seventh, eighth } =
         e.target.elements;

      const cgpa_array = [
         first.value,
         second.value,
         third.value,
         fourth.value,
         fifth.value,
         sixth.value,
         seventh.value,
         eighth.value,
      ];

      const calculate_result = (cgpa_array, formula) => {
         let i = 0;

         if (cgpa_array.includes(0.0)) {
            return (final_result = 0.0);
         } else {
            const all_gpa_percentage = cgpa_array
               .map((gpa) => (gpa * formula[i++]) / 100)
               .reduce((acc, curr) => (acc += curr), 0);
            final_result = (Math.round(all_gpa_percentage * 100) / 100).toFixed(
               2
            );

            const CGPA = final_result * 1;

            // Grade Calculation Condition
            if (CGPA === 4.0) {
               setGrade('(A+)');
            } else if (CGPA >= 3.75 && CGPA < 4.0) {
               setGrade('(A)');
            } else if (CGPA >= 3.5 && CGPA < 3.75) {
               setGrade('(A-)');
            } else if (CGPA >= 3.25 && CGPA < 3.5) {
               setGrade('(B+)');
            } else if (CGPA >= 3.0 && CGPA < 3.25) {
               setGrade('(B)');
            } else if (CGPA >= 2.75 && CGPA < 3.0) {
               setGrade('(B-)');
            } else if (CGPA >= 2.5 && CGPA < 2.75) {
               setGrade('(C+)');
            } else if (CGPA >= 2.25 && CGPA < 2.5) {
               setGrade('(C)');
            } else if (CGPA >= 2.0 && CGPA < 2.25) {
               setGrade('(D)');
            } else if (CGPA === 0.0) {
               setGrade('(F)');
            } else {
               setGrade('(?)');
            }

            // return final_result;
            return setFinalResult(final_result);
         }
      };

      calculate_result(
         cgpa_array,
         regulation === '2016' ? formula2016 : formula2010
      );
   };

   const clearForm = (e) => {
      e.preventDefault();

      Array.from(document.querySelectorAll('input')).forEach(
         (input) => (input.value = '')
      );

      setFinalResult('');
   };

   return (
      <div className="common-blue content">
         <div className="tos-container">
            <div className="calc-title text">
               <h2 style={{ textAlign: 'center' }}> CGPA Calculator </h2>
               <hr />
            </div>

            <form
               onSubmit={submitCalc}
               style={{ textAlign: 'center', width: '100%' }}
            >
               <label
                  style={{ fontSize: '20px' }}
                  className="common-blue"
                  htmlFor="single"
               >
                  Select Regulation
               </label>
               <br />

               <input
                  onClick={() => setRegulation('2016')}
                  type="radio"
                  id="single"
                  name="options"
                  defaultChecked
               />
               <label
                  style={{ marginRight: '50px' }}
                  className="common-blue"
                  htmlFor="single"
               >
                  2016
               </label>
               <input
                  onClick={() => setRegulation('2010')}
                  type="radio"
                  id="group"
                  name="options"
               />
               <label className="common-blue" htmlFor="group">
                  2010
               </label>

               {/* calculator body */}

               <div className="semester-group">
                  <div className="form-group">
                     <input type="text" name="first" required />
                     <span className="highlight"></span>
                     <span className="bar"></span>
                     <label htmlFor="first"> 1st Semester </label>
                  </div>

                  <div className="form-group">
                     <input type="text" name="second" required />
                     <span className="highlight"></span>
                     <span className="bar"></span>
                     <label htmlFor="second"> 2nd Semester </label>
                  </div>

                  <div className="form-group">
                     <input type="text" name="third" required />
                     <span className="highlight"></span>
                     <span className="bar"></span>
                     <label htmlFor="third"> 3nd Semester </label>
                  </div>

                  <div className="form-group">
                     <input type="text" name="fourth" required />
                     <span className="highlight"></span>
                     <span className="bar"></span>
                     <label htmlFor="fourth"> 4th Semester </label>
                  </div>

                  <div className="form-group">
                     <input type="text" name="fifth" required />
                     <span className="highlight"></span>
                     <span className="bar"></span>
                     <label htmlFor="fifth"> 5th Semester </label>
                  </div>

                  <div className="form-group">
                     <input type="text" name="sixth" required />
                     <span className="highlight"></span>
                     <span className="bar"></span>
                     <label htmlFor="sixth"> 6th Semester </label>
                  </div>

                  <div className="form-group">
                     <input type="text" name="seventh" required />
                     <span className="highlight"></span>
                     <span className="bar"></span>
                     <label htmlFor="seventh"> 7th Semester </label>
                  </div>

                  <div style={{ marginBottom: '15px' }} className="form-group">
                     <input type="text" name="eighth" required />
                     <span className="highlight"></span>
                     <span className="bar"></span>
                     <label htmlFor="eighth"> 8th Semester </label>
                  </div>
               </div>

               {finalResult && (
                  <span className="underlined">
                     Your CGPA : {finalResult} {grade}
                  </span>
               )}

               {/* buttons */}
               <div className="btn-section">
                  <button
                     onClick={clearForm}
                     className="clear-btn"
                     type="button"
                  >
                     Reset
                  </button>

                  <button className="calc-btn" type="submit">
                     Calculate
                  </button>
               </div>
            </form>
         </div>
      </div>
   );
};

export default Calculator;
